import { DataAttributeDefinitions } from 'scrivito'

import { pisaOpportunityDataClass } from './Pisa/pisaOpportunityDataClass'

const attributes: DataAttributeDefinitions = {}

export const Opportunity = pisaOpportunityDataClass(attributes)
